import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";
import { API_BASE_URI } from "../ApiCall";
import { ProjectPayrollActionTypes } from "./ProjectPayroll.type";
import { authHeader } from "../../utilities/utilities";

export function* fetchAllProjectPayroll(action: any): any {
  try {
    let query = "";
    if (action.payload && Object.keys(action.payload).length > 0) {
      query =
        "?" +
        Object.keys(action.payload)
          .map((key) => `${key}=${action.payload[key]}`)
          .join("&");
    }

    const response = yield axios.get(
      `${API_BASE_URI}/project-payroll${query}`,
      authHeader()
    );
    yield put({
      type: ProjectPayrollActionTypes.FETCH_ALL_PROJECT_PAYROLL_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ProjectPayrollActionTypes.FETCH_ALL_PROJECT_PAYROLL_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneProjectPayroll(action: any): any {
  try {
    const id = action.payload?.id || action.payload;
    const response = yield axios.get(
      `${API_BASE_URI}/project-payroll/${id}`,
      authHeader()
    );
    yield put({
      type: ProjectPayrollActionTypes.FETCH_ONE_PROJECT_PAYROLL_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: ProjectPayrollActionTypes.FETCH_ONE_PROJECT_PAYROLL_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllProjectPayroll() {
  yield takeLatest(
    ProjectPayrollActionTypes.FETCH_ALL_PROJECT_PAYROLL,
    fetchAllProjectPayroll
  );
}

export function* watcherFetchOneProjectPayroll() {
  yield takeLatest(
    ProjectPayrollActionTypes.FETCH_ONE_PROJECT_PAYROLL,
    fetchOneProjectPayroll
  );
}
